import style from './style.css'
const TestimonialCard = ({ name, desc, male }) => {
  return (
    <div className={style.testimonialCardContainer}>
      <div className={style.testimonialName}>
        <img src={male ? 'https://iccdn.in/campaigns/page/profile-male.png'  : 'https://iccdn.in/campaigns/page/profile-female.png'}/>
        <span>{name}</span>
      </div>
      <div className={style.testimonialDesc}>
        {desc}
      </div>
    </div>
  )
}

export default TestimonialCard


// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVD/testimonials/testimonialCard/index.js